export const wpNewsUrlRegex = /^(\/news\/)([0-9]{4})\/([0-9]{2})\//;